import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { pathOr } from 'ramda';

import { IGetOfferDataResponseSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { IState } from '../../store';
import { chatMessageSent } from '../../store/offer_chats';
import { setPhoneCollapse } from '../../store/phone_collapse';
import { toggle as toggleCallbackPopup } from '../../store/popups/callback';
import { isABAgentExperienceExperiment } from '../../utils/ab_agent_experience';
import { isLeadFactory } from '../../utils/agent';
import { AuthorBrand, IAuthorProps } from './index';
import { showCountrysideBuilderBadge } from '../../utils/suburban';
import { getDynamicCalltrackingSiteBlockId } from '../../selectors/getDynamicCalltrackingSiteBlockId';
import { getNewbuildingId } from '../../selectors';

type TAuthorProps = Pick<
  IAuthorProps,
  | 'abGroup'
  | 'agent'
  | 'developer'
  | 'offer'
  | 'offerChat'
  | 'user'
  | 'kp'
  | 'isAgentExperienceExperimentActive'
  | 'companyFoundationTime'
  | 'showCountrysideBuilderBadge'
  | 'siteBlockId'
  | 'isAuthenticated'
  | 'newbuildingId'
  | 'dynamicCalltrackingPlaceType'
  | 'isLeadFactory'
>;
type TOfferData = Pick<IGetOfferDataResponseSchema, 'agentAvailability' | 'agentReviews'>;
type TDispatchProps = Pick<IAuthorProps, 'openCallbackPopup' | 'setPhoneCollapse' | 'chatMessageSent'>;
type TStoreProps = TAuthorProps & TOfferData;

export function mapStateToProps(state: IState): TStoreProps {
  return {
    abGroup: state.abGroup,
    agent: state.offerData.agent,
    agentAvailability: state.offerData.agentAvailability,
    agentReviews: state.offerData.agentReviews,
    developer: state.offerData.newObject && state.offerData.newObject.developer,
    isAgentExperienceExperimentActive: isABAgentExperienceExperiment(state.experiments),
    companyFoundationTime: pathOr(null, ['offerData', 'company', 'yearFoundation'], state),
    kp: state.offerData.kp,
    offer: state.offerData.offer,
    offerChat: state.offerChat,
    user: state.offerData.user,
    showCountrysideBuilderBadge: showCountrysideBuilderBadge(state),
    siteBlockId: getDynamicCalltrackingSiteBlockId(state),
    newbuildingId: getNewbuildingId(state),
    isAuthenticated: !!(state.offerData.user && state.offerData.user.isAuthenticated),
    dynamicCalltrackingPlaceType: 'AuthorBrand',
    isLeadFactory: isLeadFactory(state.offerData.offer),
  };
}

export function mapDispatchToProps(dispatch: Dispatch<IState>): TDispatchProps {
  return {
    chatMessageSent: () => dispatch(chatMessageSent()),
    openCallbackPopup: () => dispatch(toggleCallbackPopup('agent', true)),
    setPhoneCollapse: () => dispatch(setPhoneCollapse()),
  };
}

// tslint:disable-next-line:no-any
export const AuthorBrandContainer = connect<TStoreProps, TDispatchProps, any>(
  mapStateToProps,
  mapDispatchToProps,
)(AuthorBrand);
